import * as React from 'react';
import type { Accept } from 'react-dropzone';

import styles from './styles.module.scss';

interface Props {
	uploading?: boolean;
	disabled?: boolean;
	error?: Nullable<string>;
	allowedTypes?: Accept;
}

const DEFAULT_TYPES = 'JPG, PNG, SVG, XLS, XLSX, DOC, DOCX, CSV or PDF';

const FileUploadMessageWithTypes = ({ disabled = false, uploading = false, error, allowedTypes }: Props) => {

	const allowedTypesString = React.useMemo(() => {
		if (!allowedTypes) {
			return DEFAULT_TYPES;
		}
		return Object.values(allowedTypes).flatMap((_types) => _types.map((_type) => _type.substring(1).toUpperCase())).join(', ');
	}, [allowedTypes]);

	if (disabled) {
		return <span className={styles['dropzone-element__text']}>Upload is disabled	</span>;
	} else if (uploading) {
		return <span className={styles['dropzone-element__text']}>Uploading...</span>;
	} else {
		return (
			<>
				{error &&
					<span className={styles['dropzone-element__error']}>
						{error}
					</span>
				}
				<span className={styles['dropzone-element__uploading-icon']}>
					<span className="icon-upload" />
				</span>
				<div className={styles['dropzone-element__text']}>
					<div className={styles['dropzone-element__text__bold']}>
						Select files or drag and drop here
					</div>
					<span className={styles['dropzone-element__text__types']}>
						{allowedTypesString}
					</span>
				</div >
			</>
		);
	}
};

export default React.memo(FileUploadMessageWithTypes);
